
const ComparisonSection = () => {
  const comparisonData = [
    {
      item: '対応範囲',
      autocrove: '業務設計〜開発〜運用',
      others: '自動化開発のみ',
      advantage: true
    },
    {
      item: '対応スピード',
      autocrove: '最速1〜2週間で初回提案',
      others: '3〜4週間',
      advantage: true
    },
    {
      item: 'コミュニケーション',
      autocrove: 'LINE・Chatwork対応',
      others: 'メール中心',
      advantage: true
    },
    {
      item: '継続率',
      autocrove: '高い継続率',
      others: '一般的',
      advantage: true
    },
    {
      item: '技術対応範囲',
      autocrove: 'GAS・VBA・AI・各種API',
      others: '限定的',
      advantage: true
    },
    {
      item: 'サポート体制',
      autocrove: '24時間以内レスポンス',
      others: '営業時間のみ',
      advantage: true
    }
  ];

  const handleConsultClick = () => {
    const event = new CustomEvent('openContactForm');
    window.dispatchEvent(event);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Autocrove <span className="text-red-500">vs</span> <span className="text-gray-500">他社</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            なぜAutocroveが選ばれるのか？他社との違いを比較してご覧ください
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="grid grid-cols-3 bg-gray-100">
              <div className="p-4 text-center font-semibold text-gray-700">比較項目</div>
              <div className="p-4 text-center font-semibold text-blue-600 bg-blue-50">Autocrove</div>
              <div className="p-4 text-center font-semibold text-gray-500">他社</div>
            </div>
            
            {comparisonData.map((row, index) => (
              <div key={index} className={`grid grid-cols-3 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                <div className="p-4 font-medium text-gray-900 border-r border-gray-200">
                  {row.item}
                </div>
                <div className="p-4 text-center border-r border-gray-200 bg-blue-50">
                  <div className="flex items-center justify-center space-x-2">
                    <span className="font-semibold text-blue-600">{row.autocrove}</span>
                    {row.advantage && (
                      <i className="ri-check-line text-green-600"></i>
                    )}
                  </div>
                </div>
                <div className="p-4 text-center text-gray-600">
                  {row.others}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-trophy-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                確かな実績
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                複数の企業・事業者様での導入実績と高い継続率。お客様満足度の高さが実績として現れています。
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-speed-line text-2xl text-red-500"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                丁寧な対応
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                最速1〜2週間での初回提案。丁寧なヒアリングと高精度な設計で、確実な課題解決を実現します。
              </p>
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="bg-gradient-to-r from-red-500 to-red-600 rounded-xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">
                他社で満足できなかった方も、ぜひ一度ご相談ください
              </h3>
              <p className="text-red-100 mb-6">
                「他社では対応できなかった」「期待した効果が得られなかった」<br />
                そんな経験をお持ちの方こそ、Autocroveの違いを実感していただけます。
              </p>
              <button 
                onClick={handleConsultClick}
                className="bg-white text-red-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                今すぐ無料相談
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
